"use client";
import { useEffect, useState } from "react";
import Templates from "@/components/templates/templates";

export default function TemplatesSection() {
  const [category, setCategory] = useState<string | null>(null);

  useEffect(() => {
    const params = window.location.search;
    const searchParams = new URLSearchParams(params);
    const kategori = searchParams.get("category");
    setCategory(kategori);
  }, []);

  return (
    <>
      {category && (
        <section className="pt-24 sm:p-24 pb-5 sm:pb-18 bg-primary">
          <h1 className="text-xl sm:text-4xl font-bold text-center text-white">
            Hasil pencarian dari kategori &quot;{category}&quot;
          </h1>
        </section>
      )}
      <section className={`p-4 ${category ? "pt-10" : "pt-24"} pb-10 sm:p-24`}>
        <Templates />
      </section>
    </>
  );
}
